import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlTrailer extends Layout {
    panelTrailerSection: Panel;
    sourceMCControl: DataSource;
    textboxLastTractorReport: Textbox;
    textboxLastTrlrReport: Textbox;
    textboxMilesParameter: Textbox;
}
